// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__eMhcr","header":"PatientQuestionnaire_header__22p8i","info":"PatientQuestionnaire_info__25N09"};